export const SET_CREDIT_CARDS = 'SET_CREDIT_CARDS'

export const setCreditCards = payload => dispatch =>
  dispatch({
    type: SET_CREDIT_CARDS,
    payload: payload
  })
